import { useContext, useEffect } from "react";
import { useState } from "react";
import AppContext from "../AppContext";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { useTranslation } from "react-i18next";

export const LiveDataQualityStatus = ({
  timeStamp,
  enabled,
  interval,
  renderType,
  parameterName,
  parameterId,
}) => {
  const { t } = useTranslation();
  const {  getTimeZoneDateTime } = useContext(AppContext);
  const [status, setStatus] = useState("critical");
  const [dataTime, setDataTime] = useState(timeStamp);

  const CalcTimeDiff = (currentTime, localLastSensorTime) => {
    if (localLastSensorTime) {
      const sixXT = 6 * (interval * 1000);
      const tenXT = 10 * (interval * 1000);
      let timeDiff = Math.max(0, currentTime - localLastSensorTime);
      if (timeDiff > tenXT) {
        setStatus("critical");
      } else if (timeDiff > sixXT) {
        setStatus("warning");
      } else {
        setStatus("normal");
      }
    }
  };

  const updateCurrentTimeAndCalcDiff = () => {
    setDataTime((pre) => {
      let localLastSensorTime = getTimeZoneDateTime(pre); // Convert lastSensorTime to local time zone
      let currentTime = getTimeZoneDateTime(new Date());
      CalcTimeDiff(currentTime, localLastSensorTime);
      return pre;
    });
  };

  useEffect(() => {
    if (timeStamp) setDataTime(timeStamp);
    if (enabled) updateCurrentTimeAndCalcDiff();
  }, [timeStamp]);

  useEffect(() => {
    updateCurrentTimeAndCalcDiff();
    const intervalId = setInterval(updateCurrentTimeAndCalcDiff, 15000); // 60000ms = 1 minute
    return () => clearInterval(intervalId);
  }, []);

  return (
    <TooltipComponent
      key={parameterId}
      content={
        enabled && timeStamp
          ? (renderType === "details" &&
              status &&
              t(`dataQualityCircle.${status}`)) ||
            (renderType === "monitor" &&
              status &&
              parameterName + " " + t(`dataQualityCircle.${status}`))
          : ""
      }
    >
      <div className="">
        <div
          className={`${
            enabled && timeStamp && status
              ? `bg-gradient-to-tr ${
                  status === "normal"
                    ? "from-green-500 to-green-700 shadow-green-700"
                    : status === "critical"
                    ? "from-red-500 to-red-700 shadow-red-700"
                    : status === "warning"
                    ? "from-amber-500 to-amber-700 shadow-amber-700"
                    : ""
                } top-2 left-1`
              : ""
          } h-3 w-3 rounded-full shadow-sm`}
        ></div>
      </div>
    </TooltipComponent>
  );
};
